// src/stores/tour.js
// *******************************************************************************
// TOUR STORE
// *******************************************************************************
// Manages the global Tour state across the application
// This prevents the Tour from unmounting during Zustand updates in other stores

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { create } from 'zustand';

// *******************************************************************************
// STATE
// *******************************************************************************
const initialState = {
  isOpen: false,
  tourComponent: null,
};

// *******************************************************************************
// STORE
// *******************************************************************************
const store = create((set, get) => ({
  ...initialState,

  // Open the tour with a specific component
  openTour: tourComponent => {
    set({
      isOpen: true,
      tourComponent,
    });
  },

  // Close the tour
  closeTour: () => {
    set({
      isOpen: false,
      // Keep the component reference to prevent unmounting issues
    });
  },

  // Reset tour state completely
  resetTour: () => {
    set(initialState);
  },
}));

// *******************************************************************************
// EXPORTS
// *******************************************************************************
export const useTourStore = store;
export const tourStore = store.getState;

// *******************************************************************************
// SELECTORS (For non-React contexts)
// *******************************************************************************
export const fromTourStore = selector => {
  if (typeof selector === 'function') {
    return selector(useTourStore.getState());
  }
  return useTourStore.getState();
};
